import React, { createContext, useContext, useEffect, useReducer } from "react";

const STORAGE_KEY = "ananda_inspiration_v1";
const LEGACY_CART_KEY = "cart";
const LEGACY_WISHLIST_KEY = "wishlist";

const InspirationContext = createContext();

function inspirationReducer(state, action) {
  switch (action.type) {
    case "HYDRATE":
      return Array.isArray(action.payload) ? action.payload : state;
    case "ADD": {
      const existing = state.find(
        (i) => i.id === action.item.id && i.finish === action.item.finish
      );
      if (existing) return state;
      return [...state, action.item];
    }
    case "REMOVE":
      return state.filter(
        (i) => !(i.id === action.id && i.finish === action.finish)
      );
    case "TOGGLE": {
      const existing = state.find(
        (i) => i.id === action.item.id && i.finish === (action.item.finish || "")
      );
      if (existing) {
        return state.filter(
          (i) => !(i.id === action.item.id && i.finish === (action.item.finish || ""))
        );
      }
      return [...state, action.item];
    }
    case "CLEAR":
      return [];
    default:
      return state;
  }
}

function readInitial() {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw) return JSON.parse(raw);
    const legacyCart = window.localStorage.getItem(LEGACY_CART_KEY);
    const legacyWishlist = window.localStorage.getItem(LEGACY_WISHLIST_KEY);
    const merged = [];
    if (legacyCart) {
      try {
        const parsed = JSON.parse(legacyCart);
        if (Array.isArray(parsed)) {
          for (const it of parsed) {
            merged.push({
              id: it.id,
              slug: it.slug,
              name: it.name,
              category: it.category,
              image: it.image,
              finish: it.color || it.finish || "",
            });
          }
        }
      } catch {}
    }
    if (legacyWishlist) {
      try {
        const ids = JSON.parse(legacyWishlist);
        if (Array.isArray(ids)) {
          for (const id of ids) {
            if (!merged.some((m) => m.id === id)) {
              merged.push({ id });
            }
          }
        }
      } catch {}
    }
    if (merged.length) {
      window.localStorage.removeItem(LEGACY_CART_KEY);
      window.localStorage.removeItem(LEGACY_WISHLIST_KEY);
    }
    return merged;
  } catch {
    return [];
  }
}

export function InspirationProvider({ children }) {
  const [list, dispatch] = useReducer(inspirationReducer, []);

  useEffect(() => {
    const initial = readInitial();
    if (initial.length) dispatch({ type: "HYDRATE", payload: initial });
  }, []);

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch {}
  }, [list]);

  return (
    <InspirationContext.Provider value={{ list, dispatch }}>
      {children}
    </InspirationContext.Provider>
  );
}

export const useInspiration = () => useContext(InspirationContext);
